/* eslint-disable */
require('./NG_BRANDSHAPE_BORDER')
require('./NG_BRANDSHAPE')
require('./NG_BRANDSHARE_REVERSE')
require('./NG_CHECKBOX_TICK')
require('./NG_CLIP_ICON')
require('./NG_CLOSE')
require('./NG_DOT_NAV_FILLED')
require('./NG_DOT_NAV')
require('./NG_DROPDOWN')
require('./NG_FACEBOOK')
require('./NG_GOOGLE_+')
require('./NG_INSTAGRAM')
require('./NG_LINKEDIN')
require('./NG_MAP_MARKER')
require('./NG_MOBILE_NAV')
require('./NG_NEXT_PREV_LARGE')
require('./NG_NEXT_PREV')
require('./NG_PINTEREST')
require('./NG_RATING_FILLED')
require('./NG_RATING')
require('./NG_SEARCH')
require('./NG_SMILE_ICON')
require('./NG_TICK')
require('./NG_TOGGLE_LARGE')
require('./NG_TOGGLE_SMALL')
require('./NG_TWITTER')



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/index.js